<template lang="pug">
    unauthorized-layout
        template(v-slot:main-content)
            .w-full.flex.flex-col.justify-center.items-center
                img.mb-6(src="@/static/logos/rmg.svg" alt="RMG" width="200")
                login-form
</template>

<script>
//Components
import UnauthorizedLayout from '@/layouts/unauthorized-layout';
import LoginForm from '@/components/views/login/';

export default {
    name: "HomePage",
    components: {
        'unauthorized-layout': UnauthorizedLayout,
        'login-form': LoginForm,
    }
}
</script>